import html2canvas from "html2canvas";

const downloadImage = (blob: string, fileName: string) => {
  const fakeLink = window.document.createElement("a");

  fakeLink.setAttribute("style", "diplay:none");
  fakeLink.download = fileName;

  fakeLink.href = blob;

  document.body.appendChild(fakeLink);
  fakeLink.click();
  document.body.removeChild(fakeLink);

  fakeLink.remove();
};

/**
 *
 * @param element the element that will be taken a screenshot
 * @param imageFileName a string containing the filename to download
 * @reference https://blog.logrocket.com/export-react-components-as-images-html2canvas/
 * @example 
 * export const ExampleComponent = () => {
  const divRef = useRef<HTMLDivElement>(null);

  const onTakeScreenshot = () => {
    if (divRef && divRef.current) {
      exportAsImage(divRef.current, "filename");
    }
  };

  return (
    <div id="summary" ref={divRef}>
      <Button onClick={onTakeScreenshot}>
        <text>take screenshot</text>
      </Button>
    </div>
  );
};
 */
const exportAsImage = async (element: HTMLElement, imageFileName: string) => {
  const canvas = await html2canvas(element);
  const image = canvas.toDataURL("image/png", 1.0);

  downloadImage(image, imageFileName);
};

export default exportAsImage;
